import React, { useState } from "react";
import { Box, Tabs, Tab } from "@mui/material";
import ViewInvoice from "./ViewInvoice";

const InvoiceReceiptTabs = () => {
  // tabValue 0: Invoice, 1: Receipt (selected by default)
  const [tabValue, setTabValue] = useState(1);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Box sx={{ width: "100%", typography: "body1" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider", marginLeft: "40px", marginRight: "40px", marginTop: "20px" }}>
        <Tabs
          value={tabValue}
          onChange={handleChange}
          aria-label="Invoice and Receipt Tabs"
          TabIndicatorProps={{ style: { backgroundColor: "#21cdc0" } }}
          sx={{
            "& .MuiTab-root": {
              fontWeight: "bold",
              fontSize: "1.1rem",
              color: "#666",
            },
            "& .Mui-selected": {
              color: "#21cdc0 !important",
            },
          }}
        >
          <Tab label="Invoice" />
          <Tab label="Receipt" />
        </Tabs>
      </Box>
      <Box>
        {tabValue === 0 && <ViewInvoice mode="invoice" />}
        {tabValue === 1 && <ViewInvoice mode="receipt" />}
      </Box>
    </Box>
  );
};

export default InvoiceReceiptTabs;
